module.exports = __webpack_public_path__ + "img/-1_0010.6b3aa14c.png";